// extracted by mini-css-extract-plugin
module.exports = {"notPaid__title":"NotPaidPage_notPaid__title__1p0f_","notPaid__toPaid":"NotPaidPage_notPaid__toPaid__2XTLq","notPaid__tariff":"NotPaidPage_notPaid__tariff__3sfyP"};